function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());






/** Shopify CDN: Minification failed

Line 8:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 9:2 Transforming const to the configured target environment ("es5") is not supported yet

**/
function initializeSlider() {
    const parent = document.querySelector(".hero_main");
    if (parent) {
      const elem = parent.querySelector(".hs-slider-main");
      var flkty = null;
      if (elem) {
        const slides = elem.querySelectorAll(".single_slide");
        //console.log("here is the slides", slides.length);
        var flkty = null;
        if (slides.length > 1) {
          if (elem.classList.contains("flickity-enabled")) {
            console.log(
              "Already Initialized",
              elem.classList.contains("flickity-enabled")
            );
          } else {
            var rotation = parseInt(elem.getAttribute("data-rotation"));
            var showArrows = elem.getAttribute("data-arrows");
            var showDots = elem.getAttribute("data-dots");
            var enbleAutoplay = elem.getAttribute("data-autoplay");
            if (showArrows.toLowerCase() === "true") {
              var nextBtn = parent.querySelector(".hero_main .next-btn");
              var prevBtn = parent.querySelector(".hero_main .prev-btn");
            }
            //console.log(rotation, showArrows, showDots, enbleAutoplay);
            var options = {
              cellAlign: "left",
              freeScroll: false,
              contain: true,
              prevNextButtons: false,
              draggable: true,
              wrapAround: true,
              pauseAutoPlayOnHover: false,
              adaptiveHeight: true,
              imagesLoaded: true,
              setGallerySize: false,
            };
            if (showDots.toLowerCase() === "true") {
              options.pageDots = true;
            } else {
              options.pageDots = false;
            }
            if (enbleAutoplay.toLowerCase() === "true") {
              options.autoPlay = parseInt(rotation);
            } else {
              options.autoPlay = false;
            }
            //console.log("options", options);
            flkty = new Flickity(elem, options);
            if (showArrows.toLowerCase() === "true") {
              nextBtn.addEventListener("click", function () {
                //console.log("Next Button Clicked");
                flkty.next();
              });
              prevBtn.addEventListener("click", function () {
                //console.log("Prev Button Clicked");
                flkty.previous();
              });
            }
          }
        }
      } else {
        console.log("No Section here...");
      }
    }
  }
  
  document.addEventListener("shopify:block:select", function (event) {
    initializeSlider();
  });
  
  document.addEventListener("shopify:block:deselect", function (event) {
    initializeSlider();
  });
  
  document.addEventListener("shopify:section:load", () => {
    initializeSlider();
  });
  
  document.addEventListener("shopify:section:reorder", () => {
    initializeSlider();
  });
  
  document.addEventListener("shopify:section:select", () => {
    initializeSlider();
  });
  
  document.addEventListener("shopify:section:deselect", () => {
    initializeSlider();
  });
  
  document.addEventListener("shopify:inspector:activate", () => {
    initializeSlider();
  });
  
  document.addEventListener("shopify:inspector:deactivate", () => {
    initializeSlider();
  });
  
  document.addEventListener("DOMContentLoaded", () => {
    initializeSlider();
  });
  
  window.addEventListener("resize", function () {
    if (window.innerWidth < 768) {
      initializeSlider();
    }
  });
  if (window.Shopify.designMode) {
    initializeSlider();
  }
  
